import { IconChecklist, IconIdBadge, IconUserScan } from "@tabler/icons-react";

export const steppersData = [
  {
    icon: <IconIdBadge />,
    label: "کد ملی",
  },
  {
    icon: <IconUserScan />,
    label: "عکس کارت ملی",
  },
  {
    icon: <IconChecklist />,
    label: "بررسی نتیجه",
  },
];
